import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueMeta from 'vue-meta'

// Icons
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlay } from '@fortawesome/pro-regular-svg-icons'
import { faPause } from '@fortawesome/pro-regular-svg-icons'
import { faAngleDoubleUp } from '@fortawesome/pro-regular-svg-icons'
import { faCloudDownload } from '@fortawesome/pro-regular-svg-icons'
import { faSpinner } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faPlay, faPause, faAngleDoubleUp, faCloudDownload, faSpinner)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})

new Vue({
  router,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
}).$mount('#app')
